const SSO_SAML_PATH_PREFIX = "/sso/saml/";

type ProviderUrlParam = string | string[] | undefined;

type ProviderUrlRouteParams = {
  providerUrl?: ProviderUrlParam;
};

function getProviderUrlParam(providerUrl: ProviderUrlParam): string {
  if (Array.isArray(providerUrl)) {
    return providerUrl.join("/");
  }

  return providerUrl || "";
}

function getProviderUrlFromPathname(pathname: string): string {
  if (!pathname.startsWith(SSO_SAML_PATH_PREFIX)) {
    return "";
  }

  return pathname.slice(SSO_SAML_PATH_PREFIX.length);
}

export function normalizeProviderUrl(rawProviderUrl: string): string {
  if (!rawProviderUrl) {
    return "";
  }

  if (rawProviderUrl.includes(":/") && !rawProviderUrl.includes("://")) {
    return rawProviderUrl.replace(":/", "://");
  }

  return rawProviderUrl;
}

export function resolveProviderUrl(
  params: ProviderUrlRouteParams,
  pathname: string
): string {
  const routeProviderUrl = normalizeProviderUrl(
    getProviderUrlParam(params.providerUrl)
  );
  const pathnameProviderUrl = normalizeProviderUrl(
    getProviderUrlFromPathname(pathname)
  );
  const providerUrl =
    routeProviderUrl && routeProviderUrl.includes("://")
      ? routeProviderUrl
      : pathnameProviderUrl || routeProviderUrl;

  if (!providerUrl) {
    return "";
  }

  try {
    return decodeURIComponent(providerUrl);
  } catch {
    return providerUrl;
  }
}
